/**
 * similar to _.range but allows you to pass a callback to create unique items.
 *
 * ex
 *   const myArray = fillArray(10, index => ({index}));
 *   myArray[8].index === 8;
 */
export function fillArray<T>(
  arrayParam: Array<unknown> | number,
  filler: (arg1: number) => T,
): Array<T> {
  const array = Array.isArray(arrayParam) ? arrayParam : Array(arrayParam);

  const returnArray: Array<T> = [];
  for (let i = 0; i < array.length; i++) {
    returnArray[i] = filler(i);
  }

  return returnArray;
}

export function first<T>(array: Array<T>): T | null | undefined {
  return array[0];
}

export function last<T>(array: Array<T>): T | null | undefined {
  return array[array.length - 1];
}

export function contains(superset: unknown[], maybeSubset: unknown[]): boolean {
  // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'boolean'.
  return maybeSubset.reduce((acc, elt) => acc && superset.includes(elt), true);
}
